// Owner purge (plan §4: POST /admin/purge; spec §5 case 7; T37). A dry run reports how many
// history entries hold the text; the purge itself replaces the text and leaves a tombstone.
import type { Http } from './http.ts';
import { purgeResultSchema, type PurgeRequest, type PurgeResult } from './schemas/purge.ts';

export * from './schemas/purge.ts';

export interface PurgeApi {
  check(request: PurgeRequest): Promise<PurgeResult>;
  /** The key makes a double press purge once (constitution §4.12). */
  purge(request: PurgeRequest, idempotencyKey: string): Promise<PurgeResult>;
}

export function createPurgeApi(http: Http): PurgeApi {
  return {
    check: (request) =>
      http.json(
        { method: 'POST', path: '/admin/purge?dryRun=true', body: request },
        purgeResultSchema,
      ),
    purge: (request, idempotencyKey) =>
      http.json(
        { method: 'POST', path: '/admin/purge?dryRun=false', body: request, idempotencyKey },
        purgeResultSchema,
      ),
  };
}
